import { useTranslation } from 'react-i18next';

import LinkButton from '../../components/LinkButton/LinkButton';

import { ArrowRightCurvedIcon, FlotiqLogo } from '../../images/shapes';

export const OauthConsentRevoked = () => {
  const { t } = useTranslation();

  return (
    <div
      className="bg-slate-900 dark:bg-slate-700 min-h-screen
                flex items-center justify-center p-2 md:p-6"
    >
      <div
        className="relative bg-white flex flex-col max-w-4xl items-center justify-center
                  rounded-lg shadow-2xl p-6 md:py-10 lg:px-10 dark:bg-slate-900 dark:text-white"
      >
        <FlotiqLogo className="h-10 mb-4 md:mb-6" />
        <h4 className="mb-4 md:mb-5 text-2xl xl:text-3xl">
          {t('OauthAccess.ConsentError')}
        </h4>
        <div className="flex flex-row items-center mt-4 md:mt-10 gap-6">
          <LinkButton
            iconPosition="start"
            link={'/'}
            iconImage={<ArrowRightCurvedIcon className="w-3 min-w-3" />}
          >
            {t('OauthAccess.ReturnButton')}
          </LinkButton>
        </div>
      </div>
    </div>
  );
};
